<template>
  <div class="shipment_product_page">
    <b-breadcrumb :items="breadCrumbs" />
    <div class="row">
      <div class="col-6 offset-3">
        <div style="padding:15px;width:100%;">
          <form @submit.prevent="addProduct" style="padding:15px;">
            <div class="form-group">
              <label for="parent_model" class="package_item_label mb-3"
                >Items *</label
              >
              <button
                class="btn btn-sm btn-success add_btn ml-3"
                @click="addItem"
                type="button"
              >
                Add Item
              </button>

              <div v-for="(v, index) in $v.product.$each.$iter" :key="index">
                <div class="form-group">
                  <div class="row">
                    <div class="col-5">
                      <label class="form_label" >Ingredient {{ parseInt(index) + 1 }}</label>
                      <b-form-select
                        :class="{ 'is-invalid': v.ingredient_id.$invalid && submit }"
                        v-model="v.ingredient_id.$model"
                        :options="dropdowns.ingredients" />
                      <div
                        class="invalid-feedback"
                        v-if="!v.ingredient_id.required && submit"
                      >
                        Ingredient is required.
                      </div>
                    </div>
                    <div class="col-3">
                      <label class="form_label"
                        >Quantity {{ parseInt(index) + 1 }}</label
                      >
                      <input
                        class="form-control"
                        v-model.trim="v.quantity.$model"
                        :class="{ 'is-invalid': v.quantity.$invalid && submit }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!v.quantity.required && submit"
                      >
                        Quantity is required.
                      </div>
                      <div
                        class="invalid-feedback"
                        v-if="!v.quantity.numeric && submit"
                      >
                        Quantity has to be a number.
                      </div>
                    </div>
                    <div class="col-3">
                      <label class="form_label" >Quantity Type {{ parseInt(index) + 1 }}</label>
                      <b-form-select
                          :class="{ 'is-invalid': v.quantity_type.$invalid && submit }"
                          v-model="v.quantity_type.$model"
                          :options="dropdowns.types" />
                      <div
                          class="invalid-feedback"
                          v-if="!v.quantity_type.required && submit"
                      >
                        Quantity Type is required.
                      </div>
                    </div>

                    <div class="col-5 mt-2">
                      <label class="form_label"
                      >Supplier Code Type {{ parseInt(index) + 1 }}</label
                      >
                      <input
                        class="form-control"
                        v-model.trim="v.supplier_code.$model"
                        :class="{ 'is-invalid': v.supplier_code.$invalid && submit }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!v.supplier_code.required && submit"
                      >
                        Supplier Code is required.
                      </div>
                    </div>

                    <div class="col-3 mt-2">
                      <label class="form_label"
                      >Supplier Batch Number {{ parseInt(index) + 1 }}</label
                      >
                      <input
                        class="form-control"
                        v-model.trim="v.supplier_batch_number.$model"
                        :class="{ 'is-invalid': v.supplier_batch_number.$invalid && submit }"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!v.supplier_batch_number.required && submit"
                      >
                        Supplier Batch Number is required.
                      </div>
                    </div>

                    <div class="col-3 mt-2">
                      <label class="form_label"
                      >Manufacturing Date {{ parseInt(index) + 1 }}</label
                      >
                      <div
                        :class="{
                          'is-invalid': v.manufacturing_date.$invalid && submit
                        }"
                      >
                        <date-picker
                          input-class="form-control"
                          v-model="v.manufacturing_date.$model"
                          input-name="manufacturing_date"
                          :first-day-of-week="1"
                          lang="en"
                        ></date-picker>
                      </div>

                      <div
                        class="invalid-feedback"
                        v-if="!v.manufacturing_date.required && submit"
                      >
                        Manufacturing Date is required.
                      </div>
                    </div>

                    <div class="col-1">
                      <button
                        class="btn btn-sm btn-danger delete_btn"
                        v-if="index > 0"
                        @click="deleteItem(index)"
                        type="button"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <b-btn variant="success" size="md" class="float-left" type="submit"
              >Add / Update Product</b-btn
            >
            <b-btn
              variant="secondary"
              size="md"
              class="float-right"
              :to="'/raw/shipments/'"
              >Cancel</b-btn
            >
          </form>
          <br />
          <br />
          <br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, numeric } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import format from "date-fns/format";
import addYears from "date-fns/addYears";

export default {
  name: "raw-shipment-product",
  components: {
    DatePicker
  },
  data() {
    return {
      product: [
        {
          ingredient_id: "",
          quantity: "",
          quantity_type: "",
          supplier_code: "",
          supplier_batch_number: "",
          manufacturing_date: ""
        }
      ],
      submit: false,
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Raw Shipments", to: { name: "raw-shipments" } },
        { text: "Raw Add Shipment Product", active: true }
      ],
      dropdowns: {
        ingredients: [],
        types: [{value: 'kg', text: 'KG'}, {value: 'g', text: 'G'}]
      }
    };
  },
  validations: {
    product: {
      required,
      $each: {
        ingredient_id: {
          required
        },
        quantity: {
          required,
          numeric
        },
        supplier_code: {
          required
        },
        supplier_batch_number: {
          required
        },
        manufacturing_date: {
          required
        },
        quantity_type: {
          required
        },
      }
    }
  },
  mounted: function() {
    this.getIngredients();
  },
  methods: {
    getIngredients: function() {
      let loader = this.$loading.show();
      this.$http.get(this.APIURL + this.BRAND + "/ingredients").then(
        response => {
          this.dropdowns.ingredients = response.data.ingredients.map((item) => ({value: item.ingredient_id, text: item.name}));
          loader.hide();
          this.getShipmentProduct();
        },
        error => {
          loader.hide();
        }
      );
    },
    getShipmentProduct() {
      let loader = this.$loading.show();
      this.$http
        .get(
          this.APIURL +
            this.BRAND +
            "/raw/shipments/" +
            this.$route.params.id +
            "/product"
        )
        .then(
          response => {
            if (response.data.length > 0) {
              this.product = response.data;
            }
            loader.hide();
          },
          error => {
            console.log(error);
          }
        );
    },
    deleteItem(index) {
      this.product.splice(index, 1);
    },
    convertToHtmlList(errors) {
      let htmlMessage = "";
      errors.forEach(function(error) {
        htmlMessage += error + "<br/>";
      });
      return htmlMessage;
    },
    addItem() {
      this.product.push({
        ingredient_id: "",
        quantity: 1,
        supplier_code: "",
        supplier_batch_number: "",
        manufacturing_date: "",
        quantity_type:""
      });
    },
    addProduct() {
      this.submit = true;
      if (!this.$v.$invalid) {
        //show loader
        let loader = this.$loading.show();

        this.$http
          .post(
            this.APIURL +
              this.BRAND +
              "/raw/shipments/" +
              this.$route.params.id +
              "/product",
            { product: this.product }
          )
          .then(
            response => {
              if (response.data.status == "failed") {
                this.$swal({
                  title: "Failed!",
                  showConfirmButton: true,
                  html: this.convertToHtmlList(response.data.errors),
                  type: "error",
                  onClose: () => {
                    loader.hide();
                  }
                });
              } else {
                this.$swal({
                  title: "Success!",
                  showConfirmButton: false,
                  timer: 1000,
                  html:
                    "Raw Shipment Product added successfully, taking you back to raw shipment list.",
                  type: "success",
                  onClose: () => {
                    loader.hide();
                    this.$router.push({ name: "raw-shipments" });
                  }
                });
              }
            },
            error => {
              console.log(error);
            }
          );
      }
    }
  }
};
</script>
